<template>
  <div
    ref="tooltip"
    v-if="isVisible"
    class="tooltip-custom"
    :class="[{'tooltip-custom--arrow': isArrow, 'tooltip-custom--arrow-right': isArrowRight, 'tooltip-custom--up': isUp}, `tooltip-custom--${horizontalAlign} tooltip-custom--${verticalAlign}`]"
    :style="{maxWidth: maxWidth}"
    v-html="htmlText"
  >
  </div>
</template>

<script>

export default {
  name: 'Tooltip',
  props: {
    htmlText: {
      type: String,
      required: false
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    horizontalAlign: {
      type: String,
      default: 'center',
      required: false
    },
    verticalAlign: {
      type: String,
      default: 'bottom',
      required: false
    },
    maxWidth: {
      type: String,
      default: 'auto'
    },
    isArrow: Boolean,
    isUp: Boolean,
    isArrowRight: Boolean
  },
  watch: {
    // TODO: Временное решение. Изменить после переработки Tooltip
    isVisible (bool) {
      if (bool) {
        this.$nextTick(() => {
          if (this.$refs.tooltip.getBoundingClientRect().left < 0) {
            this.$refs.tooltip.style.right = this.$refs.tooltip.getBoundingClientRect().left + 'px'
          }

          if (this.$refs.tooltip.getBoundingClientRect().right > window.innerWidth) {
            this.$refs.tooltip.style.left = 'auto'
            this.$refs.tooltip.style.right = '0'
          }
        })
      }
    }
  }
}
</script>

<style lang="sass">

.tooltip-custom
  position: absolute
  width: 265px
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15)
  padding: 20px
  background: #fff
  left: calc(50% - 132px)
  color: #19191E
  font-size: 14px
  top: 25px
  z-index: 2
  text-align: left

  &--arrow:after
    content: ''
    width: 15px
    height: 15px
    background-color: #fff
    border-radius: 3px
    position: absolute
    bottom: -7px
    left: 50%
    transform: translateX(-50%) rotate(45deg)

  +mmax(550)
    left: auto
    right: 0

  &--left
    left: 0

    &.tooltip-custom--arrow
      +mmax($tablet)
        left: -20px

    &:after
      +mmax($tablet)
        left: 33%

  &--right
    right: 0
    left: auto

    &.tooltip-custom--arrow
      +mmax($tablet)
        right: -20px

    &.tooltip-custom--arrow-right
      +mmax($tablet)
        right: 40px

    &:after
      +mmax($tablet)
        left: 66%

  &--top
    top: 0
    transform: translateY(-100%)

    &.tooltip-custom--up
      +mmax($tablet)
        top: -20px

  &--bottom
    top: 100%

  &--arrow-right
    // max-content: без max-width тултип в одну строку, с max-width - текст переносится
    width: max-content
    font-size: 14px
    line-height: 18px
    box-shadow: 0 2px 10px rgba(144, 144, 144, 0.25)
    border-radius: 3px
    top: -40px
    right: 40px

  &--arrow-right:after
    top: 42px
    left: auto
    right: -14px
    transform: translateX(-50%) rotate(45deg)
    box-shadow: 3px -3px 5px 0 rgba(144, 144, 144, 0.05)

.tooltip-custom__link
  position: relative
  display: inline-block
  margin-top: 5px

  &::after
    display: block
    position: absolute
    content: ''
    width: 100%
    height: 1px
    background-color: $nd-link-color
    bottom: 1px
    left: 0
    transition: width .3s ease-out

  &:hover::after
    display: none

.advantage__tooltip
  width: 240px
  z-index: 2

  +mmin($tablet)
    width: 100%

.tooltip__noty
  font-style: italic
  font-size: 11px

.tooltip-desktop-hidden
  +mmin($tablet)
    display: none
</style>
